<template>
  <div
    style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; overflow-y: scroll; overflow-x: hidden; -webkit-overflow-scrolling: touch; touch-action: pan-y; background-color: #f9fafb;">
    <div style="min-height: 100vh; padding-bottom: 10rem;">
      


      <div class="absolute inset-0 -z-10">
        <div class="absolute inset-0 bg_leaves"></div>
      </div>
      <div class="absolute inset-0 -z-10">
        <div class="absolute inset-0 bg_link"></div>
      </div>

      <div class="max-w-4xl mx-auto">
        <!-- 导航栏 -->
        <div class="px-4 py-3  flex justify-between items-center">
          <div class="flex items-center">
            <div class="mr-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors">
              <img class="w-20 mx-auto" src="../assets/airlogo.png">
            </div>
          </div>
          <div class="flex items-center">
            <!-- 系统通知按钮 -->
            <div class="py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors"
              @click="showNotificationModal = true">
              <img style="width: 60px;" src="../assets/images/lingdang.png">
            </div>
            <!-- 客服联系按钮 - 自定义聊天界面 -->
            <div class="py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors" @click="goToTopUp">
              <img style="width: 60px;" src="../assets/images/message.png">
            </div>
            
            <!-- 客服联系按钮 - 自定义聊天界面 -->
            <LiveChatWidget style="display: none;" ref="liveChatWidgetRef" :auto-load="true" :show-error="false"
              @chat-opened="handleChatOpened" @chat-closed="handleChatClosed" @initialized="handleChatInitialized"
              @error="handleChatError" @custom-chat-opened="handleCustomChatOpened"
              @custom-chat-closed="handleCustomChatClosed" />

          </div>
        </div>

        <!-- 轮播图 -->
        <div class="px-4 py-3">
          <div class="mb-2">Green News</div>
          <n-carousel autoplay :interval="3000" class="rounded-2xl">
            <img class="carousel-img rounded-2xl" v-for="banner in banners" :src="banner.imageurl"
              @click="openlink(banner.link)">
          </n-carousel>
        </div>

        <!-- 个人碳积分 -->
        <div class="m-4 rounded-lg shadow-sm p-6 card-interactive fade-in box-shadow">
          <h1 class="text-center text-xl mb-4">Your Personal Carbon Footprint</h1>
          <div class="mb-2">
            <div class="flex justify-between items-center">
              <div class="text-gray-500">Personal Carbon Footprint</div>
              <div class="text-green-500">{{ carbonFootprintValue }} tCO₂e</div>
            </div>
          </div>
          <div class="mt-2 bg-gray-200 rounded-full h-2">
            <div class="bg-primary h-2 rounded-full transition-all duration-300"
              :style="{ width: `${Math.min(100, (carbonFootprintValue / 50) * 100)}%`, background: 'linear-gradient(90deg, #4CD869 0%, #72E0DA 100%)' }">
            </div>
          </div>
        </div>

        <!-- 建议 -->
        <div class="m-4 rounded-lg shadow-sm p-6 card-interactive fade-in box-shadow">
          <div class="bg-gray-50 rounded-lg">
            <div class="flex items-center justify-between">
              <span class="text-gray-700 font-medium">You</span>
              <span class="text-lg font-bold">
                {{ carbonFootprintValue }} tCO₂e
              </span>
            </div>
            <div class="mt-2 bg-gray-200 rounded-full h-2">
              <div class="bg-primary h-2 rounded-full transition-all duration-300"
                :style="{ width: `${Math.min(100, (carbonFootprintValue / 50) * 100)}%`, backgroundColor: '#F6D41E' }">
              </div>
            </div>
          </div>
          <div class="bg-gray-50 rounded-lg">
            <div class="flex items-center justify-between">
              <span class="text-gray-700 font-medium">Singapore’s Average </span>
              <span class="text-lg font-bold">
                9.4 tCO₂e
              </span>
            </div>
            <div class="mt-2 bg-gray-200 rounded-full h-2">
              <div class="bg-primary h-2 rounded-full transition-all duration-300"
                :style="{ width: `${Math.min(100, (30 / 100) * 100)}%`, backgroundColor: '#71E0D6' }">
              </div>
            </div>
          </div>
          <div class="bg-gray-50 rounded-lg">
            <div class="flex items-center justify-between">
              <span class="text-gray-700 font-medium">World Average</span>
              <span class="text-lg font-bold">
                4.5 tCO₂e
              </span>
            </div>
            <div class="mt-2 bg-gray-200 rounded-full h-2">
              <div class="bg-primary h-2 rounded-full transition-all duration-300"
                :style="{ width: `${Math.min(100, (10 / 50) * 100)}%`, backgroundColor: '#71E0D6' }">
              </div>
            </div>
          </div>

        </div>

        <!-- 关于我们 -->
        <div class="m-4 p-6 card-interactive fade-in">
          <div class="mb-2  flex justify-between items-center">
            <h1 class="text-left font-semibold">About Us</h1>
            <router-link to="/about">
              <div class="text-gray-500">See all</div>
            </router-link>
          </div>
          <div class="w-full" style="overflow-x: scroll;">
            <div class="whitespace-nowrap">
              <div v-for="(impact, index) in climateImpacts" :key="index" @click="toabout"
                class="w-40 mr-4 bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow box-shadow inline-block">
                <div class="m-4 bg-gray-300 bg-cover bg-center flex items-end rounded-lg">
                  <img class="w-full" :src="impact.image" />
                </div>
                <div class="px-4">
                  <p class="text-gray-700 text-sm leading-relaxed w-full overflow-hidden truncate">{{ impact.title }}
                  </p>
                </div>
                <div class="px-4">
                  <p class="h-16 w-full text-gray-500 text-sm leading-relaxed overflow-hidden truncate">{{ impact.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 合作伙伴 -->
        <div class="m-4 p-6 card-interactive fade-in">
          <h1 class="text-left font-semibold">Our Partners</h1>
          <div class="w-full" style="overflow-x: scroll;">
            <div class="whitespace-nowrap">
              <img class="w-40 inline-block" src="../assets/images/partner1.png">
              <img class="w-40 inline-block" src="../assets/images/partner2.png">
              <img class="w-40 inline-block" src="../assets/images/partner3.png">
              <img class="w-40 inline-block" src="../assets/images/partner4.png">
            </div>
          </div>
        </div>


      </div>

    </div>

    <Menu></Menu>

    <!-- 系统通知弹窗 -->
    <NotificationModal v-model:show="showNotificationModal" />

  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onActivated, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useMessage } from 'naive-ui'
import { NSpin, NCarousel } from 'naive-ui'
import { useAuthStore } from '@/stores/auth'
import { pageStateManager } from '@/utils/pageStateManager'
import forestLakeBg from '@/assets/images/forest-lake-realistic.svg'
import Menu from '@/components/Menu.vue'
import NotificationModal from '@/components/user/NotificationModal.vue'
import { useLiveChatStore } from '@/stores/livechat'

import about1 from '../assets/images/about_school.png'
import about2 from '../assets/images/about_mission.png'
import about3 from '../assets/images/about_sustainable.png'
import about4 from '../assets/images/about_investment.png'

import banner1 from '../assets/images/banner1.png'
import banner2 from '../assets/images/banner2.png'
import banner3 from '../assets/images/banner3.png'
import banner4 from '../assets/images/banner4.png'

import LiveChatWidget from '@/components/common/LiveChatWidget.vue'


// 定义所有响应式变量
const router = useRouter()
const authStore = useAuthStore()
const pageLoading = ref(false)
const showNotificationModal = ref(false)
const liveChatStore = useLiveChatStore()
const message = useMessage()
const liveChatWidgetRef = ref()
const banners = ref([
  { imageurl: banner1, link: 'https://acx.net/media-release/acx-to-launch-acxrwa/?utm_source=chatgpt.com' },
  { imageurl: banner2, link: 'https://acx.net/acx-singapore/?utm_source=chatgpt.com' },
  { imageurl: banner3, link: 'https://gggi.org/lao-government-adopts-carbon-credit-decree/?utm_source=chatgpt.com' },
  { imageurl: banner4, link: 'https://www.edb.gov.sg/en/business-insights/insights/sustainability-updates-from-singapore-for-businesses-a-round-up-from-april-to-june-2025.html?utm_source=chatgpt.com' },
]);


// 首页设置
const homepageSettings = ref({
  organization_name: 'GREENIFY',
  homepage_logo: null as string | null,
  homepage_background_image: null as string | null,
  homepage_welcome_text: "Let's neutralize your"
})

// 气候影响数据 - 使用占位符图片
const climateImpacts = ref([
  {
    title: 'Company Overview',
    description: 'AirCarbon Exchange is an independent climate investment and sustainable finance institution headquartered in Singapore, dedicated to accelerating Asia\'s transition toward a low-carbon and net-zero future.',
    statistic: '',
    image: about1
  },
  {
    title: 'Our Mission',
    description: ' Across Asia, there remains a significant financing gap for infrastructure projects that support energy transition, climate resilience, and environmental sustainability.',
    statistic: '+1.1°C',
    image: about2
  },
  {
    title: 'Sustainable Infrastructure Financing and Carbon Market Platform',
    description: ' In addition to financing sustainable infrastructure, AirCarbon Exchange is  committed to building a platform that connects project developers and organizations seeking high-quality carbon credits.',
    statistic: '',
    image: about3
  },
  {
    title: 'Investment Focus',
    description: 'AirCarbon Exchange focuses on key sectors that drive sustainable development and decarbonization.',
    statistic: '',
    image: about4
  }
])

// 用户碳足迹数值
const carbonFootprintValue = ref(2.5)

// 背景样式
const backgroundStyle = computed(() => {
  const backgroundImage = homepageSettings.value.homepage_background_image || forestLakeBg
  return {
    backgroundImage: `url(${backgroundImage})`
  }
})

// 添加超时保护，确保页面不会一直卡在加载状态
let loadingTimeout: NodeJS.Timeout | null = null

// 获取首页设置
const fetchHomepageSettings = async () => {
  try {
    const response = await fetch('/api/system/homepage-settings')
    if (response.ok) {
      const data = await response.json()
      if (data.success) {
        homepageSettings.value = { ...homepageSettings.value, ...data.data }
      }
    }
  } catch (error) {
    console.error('Failed to fetch homepage settings:', error)
  }
}

// 获取用户碳足迹数据
const fetchCarbonFootprint = async () => {
  try {
    console.log('[Dashboard] 开始获取碳足迹数据...')

    const response = await fetch('/api/user/carbon-footprint', {
      headers: {
        'Authorization': `Bearer ${authStore.token}`,
        'Content-Type': 'application/json'
      }
    })

    if (response.ok) {
      const data = await response.json()
      console.log('[Dashboard] 碳足迹API响应:', data)

      if (data.success && data.data.has_data) {
        // 更新碳足迹数值
        carbonFootprintValue.value = data.data.formatted_score
        console.log('[Dashboard] 碳足迹数值已更新:', carbonFootprintValue.value)
      } else {
        console.log('[Dashboard] 没有碳足迹数据，保持默认值')
      }
    } else {
      console.error('[Dashboard] 碳足迹API请求失败:', response.status)
    }
  } catch (error) {
    console.error('[Dashboard] 获取碳足迹数据失败:', error)
  }
}

const toabout = () => {
  router.push({
    name: 'AboutUs'
  })
}

const openlink = (link: string) => {
  window.open(link, '_break');
}

// LiveChat事件处理方法
const handleChatOpened = () => {
  console.log('LiveChat聊天窗口已打开')
}

const handleChatClosed = () => {
  console.log('LiveChat聊天窗口已关闭')
}

const handleChatInitialized = () => {
  console.log('LiveChat初始化成功2')
}

const handleChatError = (error: string) => {
  console.error('LiveChat错误:', error)
  // 可以在这里添加错误处理逻辑，比如显示备用联系方式
}

// 自定义聊天界面事件处理方法
const handleCustomChatOpened = () => {
  console.log('自定义聊天界面已打开')
  // 可以在这里添加自定义聊天界面打开时的逻辑
  // 比如统计用户使用情况、更新UI状态等
}

const handleCustomChatClosed = () => {
  console.log('自定义聊天界面已关闭')
  // 可以在这里添加自定义聊天界面关闭时的逻辑
  // 比如保存聊天状态、清理资源等
}
const goToTopUp = async () => {
  // 按鈕只在 isLiveChatReady=true 時才可點擊，這裡只負責開窗
  try {
    console.log('打开 LiveChat 進行充值諮詢...')

    if (liveChatWidgetRef.value && typeof liveChatWidgetRef.value.handleChatClick === 'function') {
      await liveChatWidgetRef.value.handleChatClick()
      console.log('LiveChat打开成功')
    } else {
      // 防禦性備用：直接開窗
      liveChatStore.openChatWindow()
    }
  } catch (error) {
    console.error('打开LiveChat失败:', error)
    message.error('The customer service system is temporarily unavailable, please try again later.')
  }
}


// 组件挂载时初始化认证状态
onMounted(async () => {
  const pageName = 'Dashboard'
  console.log('[Dashboard] 开始初始化页面')

  // 使用页面状态管理器
  pageStateManager.startPageLoad(pageName)

  try {
    // 页面立即显示，不等待任何异步操作
    pageLoading.value = false

    // 异步加载首页设置（不阻塞页面显示）
    fetchHomepageSettings().catch(error => {
      console.error('首页设置加载失败:', error)
    })

    // 快速检查认证状态
    if (authStore.isAuthenticated && authStore.user) {
      console.log('[Dashboard] 用户已认证，页面已显示')
      pageStateManager.finishPageLoad(pageName)



      // 异步加载碳足迹数据
      fetchCarbonFootprint().catch(error => {
        console.error('碳足迹数据加载失败:', error)
      })

      return
    }

    // 如果有token但没有用户信息，异步初始化（不阻塞页面）
    if (authStore.token && !authStore.isInitializing) {
      console.log('[Dashboard] 有token但无用户信息，异步初始化')

      // 异步初始化，不等待结果
      authStore.initAuth().catch(error => {
        console.error('认证初始化失败:', error)
      })

    } else if (!authStore.token) {
      console.warn('[Dashboard] 没有token，用户未认证')
      pageStateManager.finishPageLoad(pageName, '用户未认证')
      router.push('/login')
      return
    }

    // 完成页面加载
    pageStateManager.finishPageLoad(pageName)

  } catch (error) {
    console.error('Dashboard初始化失败:', error)

    // 认证失败，重定向到登录页
    if (error && typeof error === 'object' && 'status' in error && error.status === 401) {
      pageStateManager.finishPageLoad(pageName, '认证过期')
      router.push('/login')
      return
    }

    // 其他错误，不阻塞页面
    pageStateManager.finishPageLoad(pageName, '初始化失败')
  } finally {
    // 确保页面加载状态被重置
    pageLoading.value = false
    console.log('[Dashboard] 页面初始化完成')
  }
})

// 页面重新激活时的处理（从其他页面返回时）
onActivated(() => {
  console.log('[Dashboard] 页面重新激活')

  // 强制重置页面加载状态
  pageLoading.value = false
  pageStateManager.finishPageLoad('Dashboard')


})

// 组件卸载时清理定时器
onBeforeUnmount(() => {
  if (loadingTimeout) {
    clearTimeout(loadingTimeout)
    loadingTimeout = null
  }
  // 清理页面状态
  pageStateManager.finishPageLoad('Dashboard')
})


</script>